import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system"
import { Link } from "react-router-dom";

const CircularContainer = styled(Box)(({ theme }) => ({
    width: '3em',
    height: '3em',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // background: '#F95799',
    border: '1px solid #F95799',
    borderRadius:'50%',
    margin: '5px',
    marginRight: '10px',
    
}))

const Circle = (props) => {

    return (
        <>
            <Box component={Link} to={`${props.categoryUrl}`} sx={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>
                {/* <CircularContainer> */}

                    <img src={props?.content} style={{ background: '#f0f0f0', width: '3em', height: '3em', borderRadius: '50%', }} />
                {/* </CircularContainer> */}

                <Typography variant="body2"  sx={{ textDecoration: 'none', color: 'black' ,fontSize:'0.5rem'}}>{props?.text.toUpperCase()}</Typography>

            </Box>

        </>
    )
}

export default Circle